export default "__VITE_ASSET__CwLpn4zL__"